export default __webpack_public_path__ + "static/media/ae.7615c13c.png";